import { SCENE_NODE } from "../ar/scene-node-names.js";
import { clampedAlpha } from "./lerp-utils.js";
import * as THREE from "three";
//#region ../src/visualization/camera-follower.ts
/**
* Camera Follower Module
*
* Creates an Object3D that tracks the camera's world position
* every frame via lerp, while keeping its own rotation at identity
* (GPS-world-aligned).
*
* The follower is placed at the scene root (outside arWorldGroup)
* so its world rotation stays identity regardless of the alignment
* matrix applied to arWorldGroup. This ensures compass cubes and
* the map mesh point to true N/E/S/W in the NUE GPS frame.
*
* Children of the follower (map mesh, compass cubes) stay
* flat / world-oriented regardless of camera rotation or
* orbit / FPS controls.
*
* @see gps-plus-slam/GpsPlusSlamJs_Docs/docs/2026-03-12-user-feedback.md Issue 8
*/
const _worldPos = new THREE.Vector3();
/**
* Create a CameraFollower and attach it as a child of the given parent.
*
* The parent should be the scene root (not arWorldGroup) so that the
* follower's world rotation stays identity — ensuring compass directions
* align with the NUE GPS frame regardless of alignment matrix changes.
*
* @param parent   Parent node — should be the scene root.
* @param lerpRate Lerp speed multiplier (default 8).
*/
function createCameraFollower(parent, lerpRate = 8) {
	const node = new THREE.Object3D();
	node.name = SCENE_NODE.CAMERA_FOLLOWER;
	parent.add(node);
	return {
		object3D: node,
		update(camera, dt) {
			camera.getWorldPosition(_worldPos);
			const alpha = clampedAlpha(lerpRate, dt);
			node.position.lerp(_worldPos, alpha);
		},
		dispose() {
			if (node.parent) node.parent.remove(node);
		}
	};
}
//#endregion
export { createCameraFollower };
